






import Vue from "vue";
import QRCode from "../components/QRCode.vue";

export default Vue.extend({
  name: "PCLanding",
  components: { QRCode },
  mounted() {
    document.body.setAttribute("style", "overflow-y: hidden");
  },
  beforeDestroy() {
    document.body.removeAttribute("style");
  }
});
